var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.patient)?_c('Tabs',{attrs:{"name":"tabsPdMonitor"},on:{"on-click":_vm.handleClickTab}},_vm._l((_vm.tabs),function(item){return _c('TabPane',{key:item.name,attrs:{"label":item.label,"name":item.name,"tab":"tabsPdMonitor"}},[(_vm.currentTab==item.name)?_c(item.component,{key:item.name,tag:"component",attrs:{"patient":_vm.patient}}):_vm._e()],1)})):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ca385e7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pdMonitor/pdMonitorIndex/parts/pdMonitorMain/index.vue
// module id = null
// module chunks = 